<template>
  <div class="container text-center">
    <b-jumbotron bg-variant="white">
      <template #header>{{ $t("authenticationError.authenticationError") }}</template>
      <template #lead>{{ $t("authenticationError.warning") }}</template>
      <hr class="my-4" />
      <b-button variant="primary" class="my-2 my-sm-0" type="button" @click="handleClick"
        >{{ $t("authenticationError.home") }}
      </b-button>
    </b-jumbotron>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "AuthenticationError",
  setup() {
    const router = useRouter();
    return {
      router
    };
  },
  methods: {
    handleClick() {
      this.router.push({ name: "LandingPage" });
    }
  }
});
</script>
